import React, { useEffect, useState, useRef } from "react";
import icons from "../../../icons.config";
import { getProductById } from "../../../Providers/shopProvider";
import { IMAGE_URL } from "../../../api-urls";

const SizeGuidePopup = ({ isOpen, togglePopup, variantId, showTrigger = true }) => {
  const [sizeChartImage, setSizeChartImage] = useState(null);
  const popupRef = useRef(null);

  useEffect(() => {
    const fetchSizeChart = async () => {
      if (isOpen && variantId) {
        console.log("Fetching size chart for productId:", variantId);
        try {
          const productData = await getProductById(variantId);
          console.log("API Response:", productData);
  
          setSizeChartImage(productData?.data?.product_size_chart?.size_chart_image || null);
        } catch (error) {
          console.error("Error fetching size chart image:", error);
        }
      } else {
        console.log("SizeGuidePopup is not open or productId is missing.");
      }
    };
  
    fetchSizeChart();
  }, [isOpen, variantId]);
  useEffect(() => {
            // Disable scrolling when modal opens
            document.body.style.overflow = "hidden";
    
            return () => {
                // Re-enable scrolling when modal closes
                document.body.style.overflow = "auto";
            };
        }, []);

  useEffect(() => {
    // Function to handle click outside
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        togglePopup(); // Close the popup
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, togglePopup]);

  return (
    <>
      {/* Conditionally Show Trigger Button */}
      {showTrigger && (
        <h3
          className="text-sm font-normal font-outfit mb-4 text-hcolor underline cursor-pointer"
          onClick={togglePopup}
        >
          SIZE GUIDE
        </h3>
      )}

      {/* Popup */}
      {isOpen && (
        <div className="fixed inset-0 top-28 z-30 backdrop-blur-sm  flex items-center justify-center">
          <div ref={popupRef} className="bg-tertiary px-6 pb-10 w-4/5 lg:w-[55%] rounded-lg justify-center lg:h-[93%] overflow-y-auto">
            {/* Close Button */}
            <div className="flex justify-end relative top-8">
              <button className="text-xl text-gray-600" onClick={togglePopup}>
                <img src={icons.close} alt="close icon" />
              </button>
            </div>

            {/* Popup Content */}
            <h3 className="text-2xl font-outfit font-normal mb-6 flex justify-center text-primary1">
              SIZE GUIDE
            </h3>
            <hr className="mb-4 text-secondary" />
            <p className="text-base mb-4 text-center font-poppins font-light my-4">
              All measurements are taken in inches.
              <br />
              <span>The fit of a garment depends on the cut, style, and fabric.</span>
            </p>

            {/* Size Chart Image */}
            <div className="lg:px-4 flex justify-center">
              {sizeChartImage ? (
                <img src={IMAGE_URL + sizeChartImage} alt="size chart" className="w-full h-full" />
              ) : (
                <p className="text-center text-gray-500">Size chart not available</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SizeGuidePopup;





// import React from "react";
// import icons from "../../../icons.config";
// import images from "../../../images.config";

// const SizeGuidePopup = ({ isOpen, togglePopup, showTrigger = true }) => {
//   return (
//     <>
//       {/* Conditionally Show Trigger Button */}
//       {showTrigger && (
//         <h3
//           className="text-sm font-normal font-outfit mb-4 text-hcolor underline cursor-pointer"
//           onClick={togglePopup}
//         >
//           SIZE GUIDE
//         </h3>
//       )}

//       {/* Popup */}
//       {isOpen && (
//         <div className="fixed inset-0 top-28 z-30 bg-black bg-opacity-50 flex items-center justify-center">
//           <div className="bg-tertiary px-6 pb-10 w-4/5 lg:w-[55%] rounded-lg justify-center lg:h-[93%] overflow-y-auto scrollable-container">
//             {/* Close Button */}
//             <div className="flex justify-end relative top-8">
//               <button className="text-xl text-gray-600" onClick={togglePopup}>
//                 <img src={icons.close} alt="close icon" />
//               </button>
//             </div>

//             {/* Popup Content */}
//             <h3 className="text-2xl font-outfit font-normal mb-6 flex justify-center text-primary1">
//               SIZE GUIDE
//             </h3>
//             <hr className="mb-4 text-secondary" />
//             <p className="text-base mb-4 text-center font-poppins font-light my-4">
//               All measurements are taken in inches.
//               <br />
//               <span>The fit of a garment depends on the cut, style, and fabric.</span>
//             </p>

//             {/* Scrollable Image Gallery */}
//             <div className="lg:px-4">
//               <img src={images.chart1} alt="size chart" className="w-full h-full" />
//               <img src={images.chart2} alt="size chart" className="w-full h-full" />
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default SizeGuidePopup;
